import {Card, CardContent, Typography} from "@mui/material";
import styles from "../Profile.module.scss";
import ProfileInfoBox from "../ProfileInfoBox/ProfileInfoBox";
import React, { FC } from "react";

type ContactInfoProps = {
  title: string;
  value: string | null | undefined;
};
const ContactInfo: FC<ContactInfoProps> = (props) => {
    const { title, value } = props;
  return (
    <Card className={styles.profileSectionCard}>
      <CardContent className={`pd-x-30 pd-y-24`}>
        <Typography variant={"h1"} component={"h1"}>
          Profile Info
        </Typography>
      </CardContent>
      <ProfileInfoBox title={title} value={value} contentClass={"borderTop0"} />
      {/* <ProfileInfoBox title="Phone" value={"+91 7865467867"} /> */}
    </Card>
  );
};

export default ContactInfo;
